import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { Representee, useGetContactInfo } from "api/common/useGetContactInfo";
import { ImpersonationSelect } from "components/UserMenu/ImpersonationSelect";
import { useGetContractIdData } from "providers/ContractIdProvider";
import theme from "tailwindTheme";
import { Avatar } from "./Avatar";

export const SelectedContactAvatar = () => {
  const { selectedContact, setSelectedContact, setSelectedContactId } =
    useGetContractIdData();
  const { data: contactData } = useGetContactInfo();

  if (!selectedContact || !contactData) {
    return <Avatar backgroundColor={"bg-white"} initials={""} />;
  }

  const indexOfContact =
    contactData?.representees?.findIndex(
      (representee) => representee.id === selectedContact.id
    ) ?? 0;
  const colorIndex = indexOfContact !== -1 ? indexOfContact + 1 : 0;
  const avatarColors = theme.colors.avatarColors;
  const selectedContactAvatarColor =
    avatarColors[
      ((colorIndex % avatarColors.length) + avatarColors.length) %
        avatarColors.length
    ];

  const hasRepresentees = (contactData?.representees?.length ?? 0) > 0;

  const handleSelect = (representee: Representee) => {
    setSelectedContact({
      id: representee.id,
      contactId: representee.contactId,
      userName: representee.name,
    });
    setSelectedContactId(representee.id);
  };

  if (!hasRepresentees) {
    return (
      <Avatar
        backgroundColor={selectedContactAvatarColor}
        initials={selectedContact?.userName?.charAt(0) ?? ""}
      />
    );
  }

  return (
    <Popover as="div" className="relative">
      <Popover.Button as="div" className="cursor-pointer">
        <Avatar
          backgroundColor={selectedContactAvatarColor}
          initials={selectedContact?.userName?.charAt(0) ?? ""}
        />
      </Popover.Button>
      <Transition
        as={Fragment}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Popover.Panel className="absolute top-full right-0 z-10 mt-1 p-2 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg">
          <ImpersonationSelect
            representees={contactData.representees ?? []}
            selected={
              contactData
                ? {
                    id: contactData.contactId ?? 0,
                    contactId: contactData._contactId ?? "",
                    name: contactData.name ?? "",
                    portfolios: [],
                    representees: [],
                  }
                : undefined
            }
            onSelect={handleSelect}
          />
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};
